module.exports = "/_next/static/images/bunny-09d752fc7bd37f5b2171f2e7fd11b57f.png";